import { createAction } from '@reduxjs/toolkit'
import { RevocationCadence } from './apiRosterSyncTypes'

export const getRosterSync = createAction('apiRosterSync/getRosterSync')

export const updateRosterSyncSettings = createAction<{
  enabled?: boolean
  revocationCadence?: RevocationCadence
}>('apiRosterSync/updateRosterSyncSettings')

export const generateApiKey = createAction<{ name?: string } | undefined>(
  'apiRosterSync/generateApiKey'
)

export const revokeApiKey = createAction<string>('apiRosterSync/revokeApiKey')

export const dismissRawKey = createAction('apiRosterSync/dismissRawKey')
